import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios'

import { getToken } from '@ghl/clientportal-core'

export async function getCustomAxiosIns(): Promise<AxiosInstance> {
  const axiosIns = axios.create()
  axiosIns.interceptors.request.use(
    async (requestConfig: InternalAxiosRequestConfig) => {
      try {
        const token = await getToken()
        requestConfig.headers['token-id'] = token
      } catch (e) {
        console.log(e)
      }
      return requestConfig
    }
  )
  return axiosIns
}
